module.exports = __webpack_public_path__ + "static/media/Icon_EE8D85.6cc214ae.png";